import { ReactComponent as FlagIcon } from "./svg/sg-flag.svg";
import "../flag-icon.scss";

export const SGFlag = () => {
  return (
    <span className="flag-icon">
      <FlagIcon />
    </span>
  );
};
